import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Form, Input, Button, Typography, Alert } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { apiClient } from '../services/apiClient';
import { getApiErrorMessage } from '../utils/apiErrors';

export const ForgotPasswordPage: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    try {
      await apiClient.post('/auth/forgot-password', { email: values.email.trim() });
      setDone(true);
    } catch (err: unknown) {
      form.setFields([
        {
          name: 'email',
          errors: [getApiErrorMessage(err, 'Request failed. Try again.')],
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 440, margin: '48px auto', padding: 24 }}>
      <Card>
        <Typography.Title level={4} style={{ marginTop: 0 }}>
          Reset password
        </Typography.Title>
        <Typography.Paragraph type="secondary">
          Enter your account email. If it exists, we will send reset instructions (check server logs in
          development when outbound email is not configured).
        </Typography.Paragraph>
        {done && (
          <Alert
            type="success"
            showIcon
            message="If an account exists for this email, a reset link has been sent."
            style={{ marginBottom: 16 }}
          />
        )}
        {!done && (
          <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: 'Please enter your email' },
                { type: 'email', message: 'Please enter a valid email' },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="Email" size="large" autoComplete="email" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading} block size="large">
                Send reset link
              </Button>
            </Form.Item>
          </Form>
        )}
        <div style={{ textAlign: 'center' }}>
          <Link to="/login">Back to sign in</Link>
        </div>
      </Card>
    </div>
  );
};
